module.exports = __webpack_public_path__ + "static/media/ManualTask.41ce35e2.svg";